import { PLAYER_REPEAT_MODES } from  '../../constants/musica/player';
import { TYPE_CONTENT } from  '../../constants/musica/player';
import * as EVENTS from '../../actions/musica/playermusica';
import DeviceStorage from '../../components/DeviceStorage/DeviceStorage';
import initialStatePlayer from '../../constants/musica/initialState.json';

const initialState = initialStatePlayer.player;
const shuffler = require('shuffle-array');

const getRandomOrderSongs = songs => shuffler(songs, { copy: true });

const findIndexWithIdPhonogram = (array, value) => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i].id === value) {
      return i;
    }
  }
  return -1;
};

const addSongsToPlaylistStartByIndex = (state, action) => {
  let songs = action.songs;
  const playlist = {};
  let elements;
  let songsShuffle;
  let elementsShuffle;
  if (action.replaceInsteadOfAppend) {
    elements = songs;
    playlist.originalContent = elements;
  } else {
    if (action.atEnd) {
      if (state.isShuffle) {
        elements = songs;
        playlist.originalContent = elements;
      } else {
        let originalLenght = state.playlist.originalContent.length - 1;
        songs = songs.map( el => {
          originalLenght++;
          return {...el, trackNumber: originalLenght + 1}
        });
        elements = [...state.playlist.originalContent, ...songs];
        playlist.originalContent = elements;
      }
    } else {
      // add songs in index
      const currentIndex = action.currentContent.index;

      let newSongs = [
        ...state.playlist.originalContent.slice(0, currentIndex + 1),
        ...songs,
        ...state.playlist.originalContent.slice(currentIndex + 1)];
      // set news track numbers
      newSongs = newSongs.map((el, index) => {
        return {...el, trackNumber: index + 1}
      });

      elements = newSongs;
      playlist.originalContent = elements;
    }
  }

  const enabledButtons = initialState;
  playlist.radioElements = [];

  return {
    ...state,
    playlist,
    currentContent: action.currentContent,
    isPaused: false,
    contentType: 'song',
    hasContentToPlay: true,
    radioArtistMode: 0,
    flagUpdate: false,
    repeatMode: PLAYER_REPEAT_MODES.SIMPLE,
    isShuffle: false
  };
};

const notifySkip = (state, action) => {
  //const skips = state.skips ? state.skips : [];
  const skips = JSON.parse(DeviceStorage.getItem("USER_SKIPS")) || [];
  DeviceStorage.setItem("USER_SKIPS", JSON.stringify(skips.concat(action.skip).slice(-6)));
  return {
    ...state,
    skips: skips.concat(action.skip).slice(-6)
  };
};

const playRadio = (state, action) => {
  const currentContent = {
    id: action.id,
    url: action.url,
    name: action.name,
    artist: [],
    dial: action.dial,
    band: action.band,
    isFavorite: action.isFavorite,
    image: action.image,
    duration: {
      seconds: 0,
      parsed: '-:-',
    },
    index: 0,
  };

  return {
    ...state,
    currentContent,
    playlist: {
      elements: [],
      duration: '',
    },
    shuffleOrder: [],
    radioArtistMode: 0,
    isPaused: false,
    isShuffle: false,
    repeatMode: PLAYER_REPEAT_MODES.SIMPLE,
    contentType: TYPE_CONTENT.RADIO_TYPE,
    hasContentToPlay: true,
  };
};

const toggleRepeat = (state) => {

  const repeatMode = state.repeatMode;

  let newRepeatMode;

  if (repeatMode === PLAYER_REPEAT_MODES.SIMPLE) {
    newRepeatMode = PLAYER_REPEAT_MODES.REPEAT_ALL;
  } else if (repeatMode === PLAYER_REPEAT_MODES.REPEAT_ALL) {
    newRepeatMode = PLAYER_REPEAT_MODES.REPEAT_SINGLE;
  } else if (repeatMode === PLAYER_REPEAT_MODES.REPEAT_SINGLE) {
    newRepeatMode = PLAYER_REPEAT_MODES.SIMPLE;
  }

  return { ...state, repeatMode: newRepeatMode };
};

const toggleShuffle = (state) => {
  const isShuffle = !state.isShuffle;
  const playlistOriginal = state.playlist.originalContent;
  const phonogramId = state.currentContent.id;
  let newStateShuffle;
  let newElements;
  let newCurrentPlaylistIndex;

  if (isShuffle) {

    const playlistIds = playlistOriginal.map((song, index) => { return { order: index, id: song.id }});
    const randomOrderSongs = getRandomOrderSongs(playlistIds);
    const currentIndexInShuffledList = findIndexWithIdPhonogram(randomOrderSongs, phonogramId);
    const firstElement = randomOrderSongs[currentIndexInShuffledList];
    const elementsFirst = randomOrderSongs.slice(0, currentIndexInShuffledList);
    const elementsLast = randomOrderSongs.slice(currentIndexInShuffledList + 1);
    const shuffleList = [firstElement, ...elementsFirst, ...elementsLast];

    newElements = shuffleList;
    newStateShuffle = true;
    newCurrentPlaylistIndex = 0;

  } else {
    const currentIndexInOriginalPlaylist = findIndexWithIdPhonogram(playlistOriginal, phonogramId);
    newElements = [];
    newStateShuffle = false;
    newCurrentPlaylistIndex = currentIndexInOriginalPlaylist;
  }

  return {
    ...state,
    currentContent: {
      ...state.currentContent,
      index: newCurrentPlaylistIndex,
    },
    playlist: {
      ...state.playlist,
      shuffleElements: newElements,
    },
    isShuffle: newStateShuffle,
  };
};

const addSpotCount = (state, action) => {
  return {
    ...state,
    spot: {
      ...state.spot,
      countSongs: state.spot.countSongs + 1
    },
  };
};

const enableSpot = (state, action) => {
  return {
    ...state,
    spot: {
      ...state.spot,
      previousContent: action.currentContent,
      isEnable: true,
      countSongs: 0,
    },
  };
};

const setFreePlaylistDetail = (state, action) => {
  return {
    ...state,
    forceFreePlaylistId: action.playlistId
  }
};

const updateCurrentContent = (state, action) => {
  return {
    ...state,
    currentContent: action.newCurrentContent
  }
};

const updateOldCurrentContent = (state, action) => {
  return {
    ...state,
    oldCurrentContent: action.oldCurrentContent
  }
};

const deleteOldCurrentContent = (state) => {
  return {
      ...state,
      oldCurrentContent: ''
    }
}

const updatePlayControl = (state, action) => ({
  ...state,
  isPaused: action.isPaused,
});

const resetRepeat = (state) => {
  return { ...state, repeatMode: 0 };
};

const updatePlayerData = (state, action) => {
  return {
    ...state,
    currentContent: action.currentContent,
    hasContentToPlay: true,
  };
};
const setFirstPlay = (state) => {
  return {
    ...state,
    firstPlay: true,
  };
};

const updateSkips = (state, action) => {
  DeviceStorage.setItem("USER_SKIPS", JSON.stringify(action.skips));
  return {
    ...state,
    skips: action.skips
  }
};

const toggleSpot = (state, action) => {
  return {
    ...state,
    spot: {
      ...state.spot,
      previousContent: state.spot.isEnable? {} : action.currentContent,
      isEnable: !state.spot.isEnable,
      countSongs: 0,
    },
  };
};

const updateStatusFavoriteContent = (state, action) => {
  return {
    ...state,
    currentContent: {
      ...state.currentContent,
      isFavorite: action.isFavorite
    }
  }
};

const updateStatusFavoritePlaylist = (state, action) => {
  const { playlist } = state;
  const { originalContent : newOriginalContent } = playlist;
  const {action: params} = action;
  const {id, isFavorite} = params;

  const foundIndex = newOriginalContent.findIndex(x => x.id === id);

  if (foundIndex !== -1){
    newOriginalContent[foundIndex].isFavorite = isFavorite;
  }
  
  return {
    ...state,
    playlist: {
      ...state.playlist,
      originalContent: newOriginalContent
    }
  }
};

const updateFlagStatus = (state, action) => {
  return {
    ...state,
    currentContent: {
      ...state.currentContent,
      flagUpdate: action.status,
    }
  }
};

function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case EVENTS.ADD_SONGS_TO_PLAYER_PLAYLIST:
    //return addSongsToPlaylist(state, action);
    break;
    case EVENTS.ADD_SONGS_TO_PLAYER_PLAYLIST_START_AT:
      return addSongsToPlaylistStartByIndex(state, action);
    case EVENTS.ENABLE_SPOT:
      return enableSpot(state, action);
    case EVENTS.NOTIFY_SKIP:
      return notifySkip(state, action);
    case EVENTS.PLAY_RADIO:
      return playRadio(state, action);
    case EVENTS.RESET_REPEAT:
      return resetRepeat(state);
    case EVENTS.SET_FREEPLAYLIST_ID:
      return setFreePlaylistDetail(state, action);
    case EVENTS.TOGGLE_REPEAT:
      return toggleRepeat(state);
    case EVENTS.TOGGLE_SHUFFLE:
      return toggleShuffle(state);
    case EVENTS.UPDATE_CURRENT_CONTENT:
      return updateCurrentContent(state, action);
    case EVENTS.UPDATE_PLAY_CONTROL:
      return updatePlayControl(state, action);
    case EVENTS.UPDATE_PLAYER_DATA:
      return updatePlayerData(state, action);
    case EVENTS.SET_FIRST_PLAY:
      return setFirstPlay(state);
    case EVENTS.UPDATE_SKIPS:
      return updateSkips(state,action);

    case EVENTS.TOGGLE_SPOT:
      return toggleSpot(state, action);
    case EVENTS.ADD_SPOT_COUNT:
      return addSpotCount(state, action);
    case EVENTS.UPDATE_FAV_STATUS_CONTENT:
      return updateStatusFavoriteContent(state, action);
    case EVENTS.UPDATE_FAV_STATUS_PLAYLIST:
      return updateStatusFavoritePlaylist(state, action);
    case EVENTS.OLD_CURRENT_TIME:
      return updateOldCurrentContent(state, action);
    case EVENTS.DELETE_OLD_CURRENT_CONTENT:
      return deleteOldCurrentContent(state);
    case EVENTS.UPDATE_FLAG_STATUS:
      return updateFlagStatus(state, action);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/musica/playermusica.js